import React from 'react';
import { PatientDetailsContextActions } from './patientDetails';
import { DashboardContextActions } from './DashboardContextActions';
import { PendingPatientContextActions } from '@/components/contextActions/PendingPatientContextActions';
import { useIsUsapHospital } from '@/modules/appContext';
import { isUUid } from '@/util';
import { useCleanPathname } from '@ianesthesie-kit/core';

export const ContextActions = () => {
  const path = useCleanPathname();
  const isUsap = useIsUsapHospital();

  if (/\/patients\/(pre|per|post)op/.test(path)) {
    return <DashboardContextActions isUsapHospital={isUsap} />;
  }

  if (!isUsap && /\/pending-patients\/?.*/.test(path)) {
    return <PendingPatientContextActions />;
  }

  const parts = path.split('/').filter(Boolean);
  if (parts[0] === 'patients' && isUUid(parts[1])) {
    return <PatientDetailsContextActions isUsapHospital={isUsap} />;
  }

  return null;
};
